import "./guide.css"
import { GuideBtn } from "./GuideBtn"
import { GuideHeader } from "./GuideHeader"
import Logo from '../Assets/logo.webp'
import { thisYear } from "../Footer/footer"

export const Guide = () => {
  return (
    <>
      <div className="bg container default">
        <GuideHeader />
        <div className="position-absolute top-0 start-50 translate-middle-x guide-body container">
          <div className="header-guide wef-font mb-3">
            <div className="guide-headline" />
            <div className="select-city" />
          </div>
          <div className="d-flex justify-content-center">
            <div className="wrap">
              <div className="d-flex flex-column gap-3">
                <GuideBtn city="MEDAN" />
                <GuideBtn city="JAKARTA" />
                <GuideBtn city="YOGYAKARTA" />
                <GuideBtn city="BANDUNG" />
                <GuideBtn city="SURABAYA" />
                <GuideBtn city="MAKASSAR" />
                <GuideBtn city="DENPASAR" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div className="col-lg-12">
          <div className="copyright-guide container">
            <div className="logo mx-auto">
              <a href="/">
                <img
                  src={Logo}
                  alt="logo"
                  width="60"
                  height="38"
                />
              </a>
            </div>

            <p>
              <br />
              © {thisYear} <a href="https://niecindonesia.com/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'black', fontWeight: 600 }}>NIEC Indonesia</a>. All Rights Reserved. CV Naresy Indonesia <br />Designed by NIEC IT Team
            </p>
          </div>
        </div>
      </section>
    </>
  )
}